import React, { Component } from 'react';
import _ from 'lodash';
import { createTableMultiSort, Column, Table, AutoSizer, InfiniteLoader } from 'react-virtualized';
import Alert from './Alert';
import ConfirmationModal from './ConfirmationModal';
import Select from 'react-select';
import TableLoader from './TableLoader';
import PatientsCSV from './PatientsCSV';

import ReactToPrint from './ReactToPrint';
import DASReport from './DASReport';
import CarePlan, { getModalDialogForPrinting, getCarePlanFileName } from './CarePlan';

const Api = require('./Config');

const VIEW_ALL = 'View all';

export default class Patients extends Component {
  constructor(props) {
    super(props);
    this.openJourney = this.openJourney.bind(this);
    this.getTableCell = this.getTableCell.bind(this);
    this.headerRenderer = this.headerRenderer.bind(this);
    this.state = {
      print_name: '',
      print_date: new Date().toISOString(),
      journeys: [],
      refFilter: '',
      tCodeFilter: '',
      statusFilter: VIEW_ALL,
      startIdx: 0,
      queryAmount: 50,
      maxRows: 0,
      isLoading: false,
      sortBy: null,
      sortDir: null,
      archiveReasons: [],
      selectedReason: null,
      targetTcodeDelete: null,
      showDeleteModal: false,
    };
    this.sort = this.sort.bind(this);
    this.hideDeleteModal = this.hideDeleteModal.bind(this);
    this.deleteJourney = this.deleteJourney.bind(this);
    this.sortState = createTableMultiSort(this.sort, {
      defaultSortBy: ['patient_ref'],
    });

    // adding timeout so we only do a search and call api when user stops typing
    // in the patient and tcode search
    this.timeout = 0;
  }

  headerRenderer({ dataKey, label }) {
    const showSortIndicator = this.sortState.sortBy.includes(dataKey);
    return (
      <div style={{ outline: 'none' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ fontSize: 11 }} title={label}>
            {label}
          </span>
          {showSortIndicator && (
            <svg width={18} height={18} viewBox="0 0 24 24">
              {this.sortState.sortDirection[dataKey] === 'ASC' ? (
                <path d="M7 14l5-5 5 5z" />
              ) : (
                <path d="M7 10l5 5 5-5z" />
              )}
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          )}{' '}
          {!showSortIndicator && (
            <span style={{ height: 18, width: 18, marginLeft: 2 }}>
              <i className="fa fa-sort"></i>
            </span>
          )}
        </div>
      </div>
    );
  }

  showDASHAlert() {
    const js = this.state.journeys;
    this.setState({ dashDialogVisible: false });
    const patientParts = Api.getPatientRefParts(js[0].patient_ref);
    const st = patientParts.mrn + patientParts.patientInitials;
    const dr = patientParts.doctorCode;
    this.alert.openLargeWithPrint(
      'DASH',
      <div style={{ height: 500, overflowY: 'scroll' }}>
        <DASReport
          ref={(ref) => {
            this.dashReport = ref;
          }}
          print_name={this.state.print_name}
          patient_ref={st}
          dr_ref={dr}
        />
      </div>,
      () => {},
      () => {
        // this is print code
        this.rtpDash.handlePrint();
      }
    );
  }

  getModalDialogForPrintingDash() {
    if (this.state.dashDialogVisible != true) {
      return;
    }
    if (this.state.journeys.length == 0) {
      this.alert.open('Error', 'No Patient Selected');
      return;
    }

    const patientParts = Api.getPatientRefParts(this.state.journeys[0].patient_ref);
    const patientName = patientParts.mrn + patientParts.patientInitials;

    return (
      <div className="modal show ">
        <div className="modal-dialog modal-sm ">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                onClick={() => {
                  this.setState({ dashDialogVisible: false });
                }}
                className="close"
                data-dismiss="modal"
              >
                &times;
              </button>
              <h4 className="modal-title">Dash Report For </h4>
              <h5 className="modal-title">{patientName} </h5>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Patient Name</label>
                <input
                  value={this.state.print_name}
                  autoFocus
                  onKeyUp={(e) => {
                    if (e.keyCode == 13) {
                      this.showDASHAlert();
                    }
                  }}
                  onChange={(e) => {
                    this.setState({ print_name: e.target.value });
                  }}
                  type="text"
                  className="form-control"
                />
              </div>
            </div>
            <div className="modal-footer">
              <div />

              <button
                onClick={() => {
                  this.showDASHAlert();
                }}
                className="btn btn-primary printBTN"
              >
                Show
              </button>
              <button
                onClick={() => {
                  this.setState({ dashDialogVisible: false, printMode: false });
                }}
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  printMe() {
    const mywindow = window.open('http://localhost:8080', 'PRINT', 'height=400,width=600');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  }

  openGuarRrail(journey) {
    this.props.history.push(`/edit_guard_rail/${journey.TID}`);
  }

  openJourney(t_code) {
    this.props.history.push(`/JourneyDetail/${t_code}`);
  }

  async getPatients(startIdx, tCodeFilter, refFilter, statusFilter, sortBy, sortDir, resetList = true) {
    this.setState({ isLoading: true });

    if (resetList) {
      this.setState({ journeys: [] });
    }

    let filters = {
      tcode: tCodeFilter.toLowerCase().replaceAll(' ', ''),
      patientRef: refFilter.toLowerCase(),
    };

    if (statusFilter != VIEW_ALL) {
      filters.status = statusFilter;
    }

    const sort = { sortBy, sortDir };

    const newIdx = resetList ? startIdx : startIdx + this.state.queryAmount;
    const journeys = await Api.getJourneysForDoctor(false, newIdx, this.state.queryAmount, filters, sort);

    let tcodes;
    if (resetList) {
      tcodes = journeys.tcodes;
    } else {
      tcodes = this.state.journeys.concat(journeys.tcodes);
    }

    this.setState({
      journeys: tcodes,
      startIdx: parseInt(journeys.newIndex),
      maxRows: parseInt(journeys.maxRows),
      isLoading: false,
      refFilter,
      tCodeFilter,
      statusFilter,
      sortBy,
      sortDir,
    });
  }

  sort({ sortBy, sortDirection }) {
    const dirs = [];
    _.each(sortBy, (a) => {
      dirs.push(sortDirection[a].toLowerCase());
    });

    this.getPatients(0, this.state.tCodeFilter, this.state.refFilter, this.state.statusFilter, sortBy[0], dirs[0]);
  }

  canArchive() {
    return this.props.userObj.role == Api.ROLE_SUPER || this.props.userObj.role == Api.ROLE_OFFICE_ADMIN;
  }

  showAppCode() {
    return this.props.userObj.role == Api.ROLE_SUPER || this.props.userObj.role == Api.ROLE_MANAGER;
  }

  componentDidMount() {
    Api.getOfficeDetail()
      .then((data) => {
        this.setState({ officeDetail: data });
      })
      .catch((err) => {
        console.log(err);
      });

    Api.getTcodeArchiveReason()
      .then((data) => {
        this.setState({ archiveReasons: data });
      })
      .catch((err) => {
        console.log(err);
      });

    this.getPatients(
      0,
      this.state.tCodeFilter,
      this.state.refFilter,
      this.state.statusFilter,
      this.state.sortBy,
      this.state.sortDir
    );
  }

  showDeleteModal(tcode, patientRef, journeyName) {
    this.setState({
      targetTcodeDelete: {
        tcode,
        patientRef,
        journeyName,
      },
      showDeleteModal: true,
    });
  }

  hideDeleteModal() {
    this.setState({
      targetTcodeDelete: null,
      showDeleteModal: false,
      selectedReason: null,
    });
  }

  deleteJourney() {
    // required to have a selected reason
    if (this.state.selectedReason == null) {
      return;
    }

    Api.deleteTCODE(this.state.targetTcodeDelete.tcode, this.state.selectedReason)
      .then((resp) => {
        if (resp.SUCCESS == 'YES') {
          this.alert.open('Deleted', 'TCODE archived!');
          this.hideDeleteModal();
          this.getPatients(
            0,
            this.state.tCodeFilter,
            this.state.refFilter,
            this.state.statusFilter,
            this.state.sortBy,
            this.state.sortDir
          );
        } else {
          this.alert.open('Error', resp.REASON);
        }
      })
      .catch((err) => {
        this.alert.open('ERR', `${err}`);
      });
  }

  getRowStyle({ index }) {
    if (index % 2 == 0) return { backgroundColor: '#f0f0f0', paddingTop: 10, paddingBottom: 10 };
    return { backgroundColor: '#ffffff', paddingTop: 10, paddingBottom: 10 };
  }

  render() {
    const uniqueRefs = this.state.journeys.reduce((acc, item) => {
      acc[item.patient_ref] = item.TID;
      return acc;
    }, {});

    return (
      <div>
        {getModalDialogForPrinting(
          this.state.askDialogVisible,
          this.state.journeys,
          this.alert,
          (obj) => {
            this.setState(obj);
          },
          this.state.print_name,
          this.state.print_date,
          this.rtp
        )}
        {this.getModalDialogForPrintingDash()}
        <div style={{ display: 'none' }}>
          <CarePlan
            phone={_.get(this.state, 'journeys[0].phone_number', '')}
            title={_.get(this.state, 'journeys[0].title', '')}
            print_date={this.state.print_date}
            print_name={this.state.print_name}
            tcodes={this.state.journeys}
            ref={(ref) => {
              this.carePlan = ref;
            }}
          />
        </div>

        <ReactToPrint
          ref={(acomp) => {
            this.rtp = acomp;
          }}
          content={() => this.carePlan}
          trigger={() => {}}
          documentTitle={getCarePlanFileName(this.state.print_name)}
        />

        <ReactToPrint
          ref={(acomp) => {
            this.rtpDash = acomp;
          }}
          content={() => this.dashReport}
          trigger={() => {}}
        />
        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '20px 0' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <h3 style={{ margin: 0, paddingRight: 20 }}>Patient T-Codes</h3>
              <button
                className="btn btn-md btn-success"
                onClick={() => {
                  this.props.history.push('/add-new-patients');
                }}
              >
                + Create New
              </button>
            </div>
            <PatientsCSV
              archived={false}
              tCodeFilter={this.state.tCodeFilter}
              refFilter={this.state.refFilter}
              statusFilter={this.state.statusFilter}
              sortBy={this.state.sortBy}
              sortDir={this.state.sortDir}
            />
          </div>
          <div className="col-sm-12 well">
            <div className="col-sm-12 col-md-6 col-lg-4">
              <div className="row">
                <div className="col-md-2">Search:</div>
                <div className="col-md-10">
                  <label style={{ width: '100%' }}>
                    Patient #
                    <input
                      onChange={(e) => {
                        const searchText = e.target.value;
                        if (this.timeout) clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                          this.getPatients(
                            0,
                            this.state.tCodeFilter,
                            searchText,
                            this.state.statusFilter,
                            this.state.sortBy,
                            this.state.sortDir
                          );
                        }, 300);
                      }}
                      className="form-control"
                      type="text"
                      placeholder="Patient #"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-3 col-lg-2">
              <label style={{ width: '100%' }}>
                T-Code:
                <input
                  onChange={(e) => {
                    const searchText = e.target.value;
                    if (this.timeout) clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                      this.getPatients(
                        0,
                        searchText,
                        this.state.refFilter,
                        this.state.statusFilter,
                        this.state.sortBy,
                        this.state.sortDir
                      );
                    }, 300);
                  }}
                  className="form-control"
                  type="text"
                  placeholder="T-Code"
                />
              </label>
            </div>
            <div className="col-sm-6 col-md-3 col-lg-2">
              <label>
                Status
                <select
                  disabled={this.state.isLoading}
                  onChange={(e) => {
                    this.getPatients(
                      0,
                      this.state.tCodeFilter,
                      this.state.refFilter,
                      e.target.value,
                      this.state.sortBy,
                      this.state.sortDir
                    );
                  }}
                  style={{ minWidth: 180 }}
                  className="form-control select"
                >
                  <option>{VIEW_ALL}</option>
                  <option>In-Progress</option>
                  <option>Missed</option>
                  <option>Completed</option>
                  <option>Created</option>
                </select>
              </label>
            </div>
            <div className="col-md-12 col-lg-4">
              <div className="row">
                <div className="col-sm-4 col-lg-4" style={{ marginTop: 18 }}>
                  <button
                    style={{ width: '100%' }}
                    disabled={Object.keys(uniqueRefs).length !== 1}
                    onClick={() => {
                      if (Object.keys(uniqueRefs).length === 1) {
                        const refValues = Object.values(uniqueRefs);
                        this.props.history.push('/add-new-patients/' + refValues[0]);
                      }
                    }}
                    className="btn btn-success"
                  >
                    Add T-Code
                  </button>
                </div>
                <div className="col-sm-4 col-lg-4" style={{ marginTop: 18, paddingRight: 0, paddingLeft: 0 }}>
                  <button
                    style={{ width: '100%' }}
                    onClick={() => {
                      this.setState({ askDialogVisible: true, print_name: '' });
                    }}
                    className="btn btn-primary"
                  >
                    Print Care Plan
                  </button>
                </div>

                <div className="col-sm-4 col-lg-4" style={{ marginTop: 18 }}>
                  <button
                    style={{ width: '100%' }}
                    onClick={() => {
                      this.setState({ dashDialogVisible: true, print_name: '' });
                    }}
                    className="btn btn-primary"
                  >
                    Print DASH
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="table-responsive" style={{ width: '100%', height: 800, display: 'flex', marginBottom: 100 }}>
            <AutoSizer>
              {({ width }) => {
                return (
                  <InfiniteLoader
                    isRowLoaded={({ index }) => {
                      return !!this.state.journeys[index];
                    }}
                    loadMoreRows={() => {
                      if (this.state.isLoading) return;
                      this.getPatients(
                        this.state.startIdx,
                        this.state.tCodeFilter,
                        this.state.refFilter,
                        this.state.statusFilter,
                        this.state.sortBy,
                        this.state.sortDir,
                        false
                      );
                    }}
                    rowCount={this.state.maxRows}
                  >
                    {({ onRowsRendered, registerChild }) => (
                      <Table
                        ref={registerChild}
                        onRowsRendered={onRowsRendered}
                        style={{ fontSize: 11 }}
                        width={width}
                        height={800}
                        headerStyle={{ outline: 'none', userSelect: 'none' }}
                        rowStyle={this.getRowStyle}
                        headerHeight={20}
                        rowHeight={40}
                        sort={this.sortState.sort}
                        rowCount={this.state.journeys.length}
                        rowGetter={({ index }) => this.state.journeys[index]}
                        noRowsRenderer={() => (this.state.isLoading ? <TableLoader /> : null)}
                      >
                        <Column
                          headerRenderer={this.headerRenderer}
                          label="Patient #"
                          dataKey="patient_ref"
                          width={width / 8}
                        />
                        <Column
                          headerRenderer={this.headerRenderer}
                          label="Group"
                          dataKey="group_name"
                          cellRenderer={this.getTableCell}
                          width={width / 12}
                        />
                        <Column headerRenderer={this.headerRenderer} label="YOB" dataKey="yob" width={width / 15} />
                        <Column
                          headerRenderer={this.headerRenderer}
                          label="Gender"
                          dataKey="gender"
                          width={width / 15}
                        />
                        {this.showAppCode() && (
                          <Column
                            headerRenderer={this.headerRenderer}
                            label="app_id"
                            dataKey="app_id"
                            width={width / 15}
                          />
                        )}
                        <Column
                          headerRenderer={this.headerRenderer}
                          label="Journey"
                          dataKey="journey_name"
                          width={width / 3}
                        />
                        <Column
                          headerRenderer={this.headerRenderer}
                          label="T-Code #"
                          cellRenderer={this.getTableCell}
                          dataKey="t_code"
                          width={width / 11}
                        />
                        <Column
                          headerRenderer={this.headerRenderer}
                          label="Created"
                          cellRenderer={this.getTableCell}
                          dataKey="journey_start_date"
                          width={width / 10}
                        />
                        <Column label="Status" dataKey="STATUS" width={width / 10} />
                        <Column
                          label="&nbsp;&nbsp;&nbsp;  View&nbsp;"
                          cellRenderer={this.getTableCell}
                          dataKey="view"
                          width={width / 19}
                        />
                        <Column
                          label="&nbsp;&nbsp;&nbsp;  Edit  "
                          cellRenderer={this.getTableCell}
                          dataKey="edit"
                          width={width / 19}
                        />
                        {this.canArchive() && (
                          <Column
                            label="Archive"
                            cellRenderer={this.getTableCell}
                            dataKey="archive"
                            width={width / 19}
                          />
                        )}
                      </Table>
                    )}
                  </InfiniteLoader>
                );
              }}
            </AutoSizer>
          </div>
        </div>

        <ConfirmationModal
          show={this.state.showDeleteModal}
          title={
            <>
              {this.state.targetTcodeDelete && (
                <div>
                  <h3 style={{ fontSize: 18, fontWeight: 900 }}>
                    Confirm archive for {this.state.targetTcodeDelete.patientRef} T-Code:{' '}
                    {this.state.targetTcodeDelete.tcode}
                  </h3>
                  <p style={{ fontSize: 14 }}>Journey: {this.state.targetTcodeDelete.journeyName}</p>
                </div>
              )}
            </>
          }
          handleClose={this.hideDeleteModal}
          handleConfirm={this.deleteJourney}
          confirmClass={'btn-danger ' + (this.state.selectedReason ? '' : 'disabled')}
        >
          <p>Please select a reason for archiving tcode:</p>
          <Select
            onChange={(obj) => {
              this.setState({ selectedReason: obj.id });
            }}
            isSearchable={false}
            getOptionLabel={(a) => a.reason_text}
            getOptionValue={(a) => a.id}
            options={this.state.archiveReasons}
          />
        </ConfirmationModal>

        <Alert
          ref={(a) => {
            this.alert = a;
          }}
        />
      </div>
    );
  }

  getTableCell({ cellData, columnData, columnIndex, dataKey, isScrolling, parent, rowData, rowIndex }) {
    if (dataKey === 'group_name') {
      return cellData || 'None';
    }

    if (dataKey === 'journey_start_date') {
      return Api.getDateFormat(rowData.journey_start_date);
    }

    if (dataKey === 't_code') {
      return Api.formatTCode(rowData.t_code);
    }
    if (dataKey === 'view') {
      return (
        <div onClick={() => this.openJourney(rowData.t_code)} className="btn   ">
          <i style={{ fontSize: 20, color: '#5555ee' }} className="fa fa-eye" aria-hidden="true"></i>{' '}
        </div>
      );
    }
    if (dataKey == 'edit') {
      return rowData.has_guard_rail == 'Y' || rowData.show_emergency_alert == 'Y' || rowData.change_group ? (
        <div onClick={() => this.openGuarRrail(rowData)} className="btn   ">
          <i style={{ fontSize: 20, color: '#000000' }} className="fa fa-edit" aria-hidden="true"></i>{' '}
        </div>
      ) : null;
    }

    if (dataKey === 'archive') {
      return (
        <div
          onClick={() => this.showDeleteModal(rowData.t_code, rowData.patient_ref, rowData.journey_name)}
          className="btn"
        >
          <i style={{ fontSize: 20, color: '#ff0000' }} className="fa fa-trash" aria-hidden="true"></i>{' '}
        </div>
      );
    }
  }
}
